<template>
  <div class="page event-management">
    <management-nav></management-nav>
    <side-menu activeNav="Check-In" childName="Check-In Status"></side-menu>

    <div class="content">
      <div class="dashboard">
        <heading title="Check-in"></heading>

        <button class="btn">
          <img class="white_icon" src="@/assets/img/plus.svg" />Add Checkin
        </button>
        <div class="search-inp">
          <input type="text" placeholder="Search Attendees" />
        </div>
        <table>
          <thead>
            <td>Attendee Name</td>
            <td>Email</td>
            <td>Ticket Type</td>
            <td>Status</td>
          </thead>

          <tbody>
            <tr v-for="(person, index) in attendees" :key="index">
              <td data-label="Attendee Name">{{ person.name }}</td>
              <td data-label="Email">{{ person.email }}</td>
              <td data-label="Ticket Type">{{ person.ticket }}</td>
              <td data-label="Status">{{ person.status }}</td>
            </tr>
          </tbody>
          <p>
            <button @click="prevPage">Previous</button>
            <button @click="nextPage">Next</button>
          </p>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import BtnNav from "@/components/BtnNav.vue";
import managementBar from "@/components/managementBar.vue";
import managementMenu from "@/components/managementMenu.vue";
import Title from "@/components/Title.vue";

const fb = require("../firebaseConfig.js");
const db = fb.default.db;
var moment = require("moment");

export default {
  name: "events",
  components: {
    "btn-nav": BtnNav,
    "management-nav": managementBar,
    "side-menu": managementMenu,
    heading: Title,
  },
  data() {
    return {
      event: null,
      attendees: [
        {
          name: "Yarden Negri",
          email: "yardenroee@gmail.com",
          ticket: "VIP",
          status: "Checked-in",
        },
        {
          name: "Yarden Negri",
          email: "yardenroee@gmail.com",
          ticket: "VIP",
          status: "Checked-in",
        },
        {
          name: "Yarden Negri",
          email: "yardenroee@gmail.com",
          ticket: "VIP",
          status: "Checked-in",
        },
        {
          name: "Yarden Negri",
          email: "yardenroee@gmail.com",
          ticket: "VIP",
          status: "Checked-in",
        },
        {
          name: "Yarden Negri",
          email: "yardenroee@gmail.com",
          ticket: "VIP",
          status: "Checked-in",
        },
        {
          name: "Yarden Negri",
          email: "yardenroee@gmail.com",
          ticket: "VIP",
          status: "Checked-in",
        },
        {
          name: "Yarden Negri",
          email: "yardenroee@gmail.com",
          ticket: "VIP",
          status: "Checked-in",
        },
        {
          name: "Yarden Negri",
          email: "yardenroee@gmail.com",
          ticket: "VIP",
          status: "Checked-in",
        },
        {
          name: "Yarden Negri",
          email: "yardenroee@gmail.com",
          ticket: "VIP",
          status: "Checked-in",
        },
        {
          name: "Yarden Negri",
          email: "yardenroee@gmail.com",
          ticket: "VIP",
          status: "Checked-in",
        },
        {
          name: "Yarden Negri",
          email: "yardenroee@gmail.com",
          ticket: "VIP",
          status: "Checked-in",
        },
        {
          name: "Yarden Negri",
          email: "yardenroee@gmail.com",
          ticket: "VIP",
          status: "Checked-in",
        },
        {
          name: "Yarden Negri",
          email: "yardenroee@gmail.com",
          ticket: "VIP",
          status: "Checked-in",
        },
        {
          name: "Yarden Negri",
          email: "yardenroee@gmail.com",
          ticket: "VIP",
          status: "Checked-in",
        },
        {
          name: "Yarden Negri",
          email: "yardenroee@gmail.com",
          ticket: "VIP",
          status: "Checked-in",
        },
        {
          name: "Yarden Negri",
          email: "yardenroee@gmail.com",
          ticket: "VIP",
          status: "Checked-in",
        },
        {
          name: "Yarden Negri",
          email: "yardenroee@gmail.com",
          ticket: "VIP",
          status: "Checked-in",
        },
      ],
      progress: "0%",
    };
  },
  firestore() {
    return {
      event: db.collection("event").doc(this.$route.params.id),
    };
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scope>
.search-inp {
  display: flex;
  justify-content: flex-end;
  input {
    width: 35%;
  }
}

@media screen and (max-width: 700px) {
  .search-inp {
    justify-content: center;
    input {
      width: 100%;
      margin-top: 20px;
    }
  }
}
</style>

